<template>
    <div class="card ">
        <div class="row">
            <Toast/>
            <DataTable :value="all_crews" :paginator="true" :rows="10"
            :paginatorTemplate="paginatorTemplate"
            :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll" scrollable 
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            stripedRows :loading="loading"
            :globalFilterFields="['first_name']"
            v-model:filters="filters" >
                <template #empty>
                    <div class="col text-center">
                        No records found
                    </div>
                </template>
                <template #header>
                    <div class="row">
                        <div class="table-header flex flex-column md:flex-row md:justify-content-end">
                            <span class="p-input-icon-left ">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Keyword Search" class="input_small"/>
                            </span>
                        </div>
                    </div>
                </template>
                <Column header="First name" field="first_name" :sortable="true"/>
                <Column header="Last name" field="last_name" :sortable="true"/>
                <Column header="DNI / PASSPORT" field="dni_pass" :sortable="true" style="max-width: 12rem;"/>
                <Column header="Call" field="id_call" :sortable="true">
                    <template #body="slotProps">
                        {{format_date(slotProps.data.id_call.arrival_datetime)}} -> {{slotProps.data.id_call.id_ship.name}}
                    </template>
                </Column> 
                <Column v-if="$can('change','crew')" header="Edit" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined" @click="edit_crew(slotProps.data)"/>
                    </template>
                </Column>
                <Column v-if="$can('delete','crew')" header="Delete" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined" @click="confirm_delete_crew(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog v-model:visible="crew_dialog" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}" header="Crew Details" :modal="true" class="p-fluid">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10 md:col-6">
                    <div class="p-float-field">
                        <label for="first_name" class="ps-1 pb-1"> <strong>First name</strong> </label>
                        <InputText id="first_name" v-model.trim="crew.first_name" required="true" autofocus :class="{'p-invalid': submitted && !crew.first_name || crew_errors.first_name}" />
                        <small v-if="Object.keys(crew_errors).length !== 0 && crew_errors.first_name" class="p-error"><span v-for="error in crew_errors.first_name" :key="error">{{error}}<br></span></small>
                        <small class="p-error" v-if="submitted && !crew.first_name">First name is required.</small>
                    </div>
                </div>
                <div class="col-10 md:col-6">
                    <div class="p-float-field">
                        <label for="last_name" class="ps-1 pb-1"><strong>Last name</strong>  </label>
                        <InputText id="last_name" v-model.trim="crew.last_name" required="true" autofocus :class="{'p-invalid': submitted && !crew.last_name || crew_errors.last_name}" />
                        <small class="p-error" v-if="submitted && !crew.last_name">Last name is required.</small>
                        <small v-if="Object.keys(crew_errors).length !== 0 && crew_errors.last_name" class="p-error"><span v-for="error in crew_errors.last_name" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="dni_pass" class="ps-1 pb-1"> <strong>DNI / PASSPORT</strong> </label>
                        <InputText id="dni_pass" v-model.trim="crew.dni_pass" required="true" autofocus :class="{'p-invalid': submitted && !crew.dni_pass || crew_errors.dni_pass}" />
                        <small v-if="Object.keys(crew_errors).length !== 0 && crew_errors.dni_pass" class="p-error"><span v-for="error in crew_errors.dni_pass" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="call" class="ps-1 pb-1"> <strong>Call</strong> </label>  
                        <Dropdown id="id_call" v-model="crew.id_call" :options="all_calls" optionLabel="ship_agent" :filter="true">
                            <template #value="slotProps">
                                <div v-if="slotProps.value && !slotProps.value.value">
                                    <span>{{format_date(slotProps.value.arrival_datetime)}} - {{slotProps.value.id_ship.name}}</span>
                                </div>
                                <div v-else-if="slotProps.label && slotProps.value.value">
                                    <span>{{format_date(slotProps.option.arrival_datetime)}} - {{slotProps.option.id_ship.name}}</span>
                                </div>
                            </template>
                            <template #option="slotProps">
                                <div> {{format_date(slotProps.option.arrival_datetime)}} - {{slotProps.option.id_ship.name}} </div>
                            </template>
                        </Dropdown>
                        <small v-if="Object.keys(crew_errors).length !== 0 && crew_errors.id_call" class="p-error"><span v-for="error in crew_errors.id_call" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Cancel" class="p-button-text" @click="hide_crew_dialog"/>
            <Button label="Save" @click="save_crew" />
        </template>
        
    </Dialog>

    <Dialog v-model:visible="delete_crew_dialog" :style="{width: '450px'}" header="Confirm" :modal="true">
        <div class="confirmation-content">
            <span v-if="crew">Are you sure you want to delete <b>{{crew.name}}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" class="p-button-text" @click="delete_crew_dialog = false"/>
            <Button label="Yes" @click="deleteCrew" />
        </template>
    </Dialog>

</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext';
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import { FilterMatchMode } from 'primevue/api';
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    name: "TableCrews",    
    components: {
        DataTable,
        Column,
        InputText,
        Button,
        Toast,
        Dialog,
        Dropdown
    },
    data() {
        return {
            crew: {},
            crew_errors: {},
            crew_dialog: false,
            delete_crew_dialog: false,
            submitted: false,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        if(this.all_crews.length == 0) {
            this.loading = true
            await this.$store.dispatch('load_all_crews')
            this.loading = false
        }
    },

    async unmounted(){
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        all_crews: function() {
            return this.$store.getters.all_crews
        },
        all_calls: function(){
            return this.$store.getters.all_calls
        },
        get_crew_errors: function() {
            return this.$store.getters.get_crew_errors
        }
    },
    methods: {

        async handleResize(){
            if (window.innerWidth <= 767){
                this.paginatorTemplate = "CurrentPageReport PrevPageLink NextPageLink"
            } else {
                this.paginatorTemplate = "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            }
        },

        format_date(value) {
            if(value instanceof Date){
                return value.toISOString().split('T')[0]
            } else {
                return value.split('T')[0]
            }
        },
        delete_crew: function() {
            this.DELETE_CREW(this.crew.id)
        },
        confirm_delete_crew(crew) {
            this.crew = crew.data;
            this.delete_crew_dialog = true;
        },
        deleteCrew() {
            this.$store.dispatch('delete_crew', this.crew.id)
            this.delete_crew_dialog = false;
            this.$toast.removeAllGroups();
            this.$toast.add({severity:'success', summary: 'Successful', detail: 'Crew deleted', life: 3000});
        },
        edit_crew(crew) {
            this.crew = {...crew};
            this.crew_dialog = true;
            
        },
        async save_crew() {
            this.submitted = true;
			if (this.crew.first_name.trim()) {

                await this.$store.dispatch('update_crew', this.crew)
                this.crew_errors = this.get_crew_errors
                if(Object.keys(this.crew_errors).length === 0){
                    this.hide_crew_dialog()
                    this.crew = {};
                    this.$toast.removeAllGroups();
                    this.$toast.add({severity:'success', summary: 'Successful', detail: 'Crew modified', life: 3000});
                }
            }
        },
        hide_crew_dialog() {
            this.crew_dialog = false;
            this.submitted = false;
        },
    },
    validations() {
        return {
            first_name: { required },
            last_name: { required },
            dni_pass: { required },
            id_call: { required },

        }
    },
}
</script>

<style scoped>
.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    border-radius: 10px;
    margin-bottom: 1rem;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

:deep(.p-inputtext){
    font-size: 1rem;
    margin: auto;
}

.input_small{
    font-size: .8rem !important; 
}

</style>